import { Component, Input, OnInit } from '@angular/core';
import { BsModalRef } from 'ngx-bootstrap/modal';

@Component({
  selector: 'xchange-error-modal',
  templateUrl: './error-modal.component.html',
  styleUrl: './error-modal.component.scss'
})
export class ErrorModalComponent {
  @Input()public title:any;
  
  constructor( public bsModalRef: BsModalRef) { }

  ngOnInit(): void {
    
    
  }

  onHideModal() {
    this.bsModalRef.hide();
  }
}
